import React, {useEffect, useState} from 'react';
import {apiPath, serverToken} from "../../utils/api";
import axios from "axios";
import {useNavigate} from 'react-router-dom';
import Hashids from 'hashids'

import {CgSpinner} from "react-icons/cg";
import CustomPagination from "../../components/CustomPagination";
import Lottie from "lottie-react";
import cat_gray from "../../anim/cat_gray.json";


function Requests() {

    const navigate = useNavigate();
    const hashids = new Hashids('', 10)

    const [isLoading, setIsLoading] = useState(true);
    const [requests, setRequests] = useState(null);
    const [data,setData] = useState(null);
    const [currentPage,setCurrentPage] = useState(1);

    useEffect(() => {

        const fetchRequests = async (page) => {
            setIsLoading(true);

            const headers = {
                'Authorization': serverToken,
            };

            const res = await axios.get(apiPath + '/admin-trip-requests?page=' + page, {headers});
            setRequests(res.data.data);
            setData(res.data)
            setIsLoading(false);
        }

        fetchRequests(currentPage)

    }, [currentPage]);

    if (!requests) {
        return (
            <div className="container mx-auto flex justify-center items-center">
                <CgSpinner className="w-8 h-8 animate-spin text-gray-400"/>
            </div>
        );
    }

    if (requests.length === 0) {
        return (
            <div className="container mx-auto h-screen flex flex-col justify-center items-center">
                <Lottie className="w-full lg:w-1/6" animationData={cat_gray} loop={true} />
                <p className="py-5">No hay nada para mostrar</p>
            </div>
        );
    }

    // Change page
    const paginateFront = () => setCurrentPage(currentPage + 1);
    const paginateBack = () => setCurrentPage(currentPage - 1);

    const tripState = (type) => {

        switch(type) {

            case "A":   return <span className="rounded-full px-3 py-1 mt-2 bg-green-50 text-green-400 text-xs font-normal">Aprovado</span>;
            case "C":   return <span className="rounded-full px-3 py-1 mt-2 bg-red-50 text-red-400 text-xs font-normal">Cancelado</span>;
            case "P": return <span className="rounded-full px-3 py-1 mt-2 bg-sky-50 text-sky-400 text-xs font-normal">Pendiente</span>;

            default: return <span className="rounded-full px-3 py-1 mt-2 bg-sky-50 text-sky-400 text-xs font-normal">Sin definir</span>
        }
    }

    const handleRequestDetails = (id) => {
        let hashedID = hashids.encode(id)
        navigate("/solicitud/" + hashedID)
    };

    return (
        <div className="px-4 pb-5 overflow-y-auto bg-white rounded-lg">
            <table className="w-full whitespace-nowrap">
                <thead>
                <tr className="h-16 w-full text-sm leading-none text-gray-800">
                    <th className="font-normal text-left text-start">Cliente</th>
                    <th className="font-normal text-left text-start">Recogida</th>
                    <th className="font-normal text-left text-start">Despacho</th>
                    <th className="font-normal text-left text-center">Estado</th>
                    <th className="font-normal text-left text-center">Acciones</th>
                </tr>
                </thead>
                <tbody className="w-full">
                {requests.map((request) => {
                    return (
                        <tr key={request.id} className="h-20 text-sm leading-none text-gray-800 bg-white hover:bg-gray-50 border-b border-t border-gray-100">
                            <td className="pl-4">
                                <div className="flex items-center">
                                    <div className="w-10 h-10">
                                        <img className="w-full h-full rounded"
                                             src={ request.user.avatar !== "null" ? request.user.avatar : "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909__340.png"}
                                             alt=""/>
                                    </div>
                                    <div className="px-4 ">
                                        <div className="flex items-center">
                                            <p className="font-medium">{request.user.name}</p>

                                            {request.user.role === 'A'
                                                ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                       fill="currentColor" className="w-4 h-4 text-sky-400">
                                                    <path fillRule="evenodd"
                                                          d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                                                          clipRule="evenodd"/>
                                                </svg>
                                                :
                                                <>
                                                </>
                                            }

                                        </div>

                                        <p className="text-xs leading-3 text-gray-600 pt-2">{request.user.email}</p>
                                    </div>
                                </div>
                            </td>
                            <td className="text-start px-4">
                                <p className="text-sm leading-none text-gray-700">{request.client_address}</p>
                            </td>

                            <td className="text-start px-4">
                                <p className="text-sm leading-none text-gray-700">{request.destination_address}</p>
                            </td>
                            <td className="text-center px-4 lg:px-0">
                                {
                                    tripState(request.status)
                                }
                            </td>
                            <td className="text-center px-4 lg:px-0">
                                <button onClick={()=> handleRequestDetails(request.id)} className="text-sm text-gray-600 hover:text-amber-400 mx-2">Ver solicitud</button>
                            </td>
                        </tr>
                    );
                })}

                </tbody>
            </table>

            <CustomPagination
                currentPage={data.current_page}
                paginateBack={paginateBack}
                paginateFront={paginateFront}
                postsPerPage={data.per_page}
                totalPosts={data.last_page}
                current={requests.length}
                totalUsers={data.total}
            />

        </div>
    );
}

export default Requests;